module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GY_3X.9eb54991.tom";